// src/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  defaultSearch: null,
  defaultType: "RELATIVE",
};

const billSlice = createSlice({
  name: "bill",
  initialState,
  reducers: {
    setSearchDefaultValue(state, action) {
      state.defaultSearch = action.payload;
    },
    setSearchDefaultType(state, action) {
      state.defaultType = action.payload;
    },
    clearSearchDefaultValue(state) {
      state.defaultSearch = null;
    },
    clearSearchDefaultType(state) {
      state.defaultType = "RELATIVE";
    },
  },
});

export const { setSearchDefaultValue , setSearchDefaultType , clearSearchDefaultValue , clearSearchDefaultType } =
  billSlice.actions;
export default billSlice.reducer;
